var explanations = {};

explanations.visibility = {
  0: "This quiz is not listed. Teams can join via link.",
  1: "This quiz is publicly listed. Teams can see it on their dashboards as long as they can join."
};

explanations.visibility_names = {
  0: "not listed",
  1: "public"
};

explanations.visibility_calendar = {
  0: "This quiz is not listed in the calendar.",
  1: "This quiz is listed in the calendar if it has a date set."
};

explanations.quiz_status_names = {
  0: "new",
  1: "open",
  2: "started",
  3: "closed",
  4: "ended",
  5: "finalized"
};

explanations.quiz_status = {
  0: "This quiz has been created. It is not visible to anyone but you.",
  1: "This quiz has been opened. Teams can join the quiz, but not submit scores.",
  2: "This quiz has started. Teams can submit scores, new teams can stil join in.",
  3: "This quiz has been closed. Teams can submit scores, but no new teams can join in.",
  4: "This quiz has ended. No one can submit scores. You can still change the scores.",
  5: "This quiz has been finalized. No changes are possible."
};

explanations.quiz_status_next = {
  0: "Nonsense",
  1: "When you open the quiz, teams can join in, but not submit scores until you choose to start.",
  2: "When you start the quiz, teams can start submitting scores. Other teams can still join in.",
  3: "When you close the quiz, teams can still submit scores but no new teams can join in.",
  4: "When you end the quiz, teams can no longer submit scores. You however can still change scores and other data.",
  5: "When you finalize the quiz, its data can no longer be changed by anyone."
};

explanations.quiz_action_next = {
  0: "Open Quiz",
  1: "Start Quiz",
  2: "Close Quiz",
  3: "End Quiz",
  4: "Finalize Quiz",
  5: "Nonsense"
};

explanations.quiz_action_next_variants = {
  0: "info",
  1: "success",
  2: "warning",
  3: "danger",
  4: "dark",
  5: "Nonsense"
};

module.exports = explanations;
